import { useState, useEffect } from 'react';
import { Device } from "../../Types";
import Product from '../../Components/product';
import { useGlobalContext } from "../../Context/GlobalContext";
import PlusCircle from '../../Components/plusCircle';
import { Grid2 as Grid } from '@mui/material';

const DeviceList = (
    { handleAddNew, editDevice, setView }: 
    { handleAddNew: any, editDevice: Function, setView: Function }
) => {
    const { deviceManager, dbManager, showPopup } = useGlobalContext();

    const [devices, setDevices] = useState<Device[]>(deviceManager.devices);
    const [addIsHovered, setAddIsHovered] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            await deviceManager.getDevices();
            setDevices(deviceManager.devices);
        }
        fetchData();
    }, [deviceManager, dbManager]);

    const handleDelete = async (id: number) => {
        showPopup({
            title: 'Delete Device',
            content: 'Are you sure you want to delete this device?',
            onConfirm: async () => {
                setDevices(deviceManager.devices.filter((device: Device) => device.id !== id));
                await deviceManager.deleteDevice(id);
            }
        })
    }

    return (
        <div className="products">
            <Grid container spacing={1} rowGap={5} wrap="wrap" className="product-list">
                <Grid size={{ xs: 3}} onMouseEnter={() => setAddIsHovered(true)} onMouseLeave={() => setAddIsHovered(false)}>
                    <div className='new-product-container'>
                        <div className="product new-product list-product" onClick={handleAddNew}>
                            <div style={{marginBottom: "10px"}}>
                                <PlusCircle invert={addIsHovered} width='2vw'/>
                            </div>
                            <div style={{fontSize: '1vw'}}>ADD NEW PRODUCT</div>
                            <div style={{fontSize: '1vw', marginTop: '10px'}}>OR</div>
                            <div style={{fontSize: '1vw', marginTop: '10px'}}>CONNECT EXISTING</div>
                            <div style={{fontSize: '1vw', marginTop: '2px'}}>DEVICE</div>
                        </div>
                    </div>
                </Grid>
                {devices.map((device: Device) => (
                    <Grid size={{ xs: 3}} key={device.id}>          
                        <Product 
                            className='list-product' 
                            deviceId={device.id} 
                            deviceHardwareId={device.hardwareId} 
                            type={device.type}
                            onClick={() => editDevice(device.id)} handleDelete={handleDelete}
                        />
                        <div className="product-type">{device.type.name?.toUpperCase()}</div>
                        <div style={{fontSize: '2vh'}}>{device.name}</div>
                    </Grid>
                ))}
            </Grid>
        </div>
    );
};

export default DeviceList;
